import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const PaymentLinkLine = loadable(() => import('./PaymentLinkLine'), {});
